/**
 * Button
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'button';

class Button extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body,
        container: this.element.querySelector(`.${componentName}__container`),
        anchor: this.element.querySelector('a'),
    };

    /**
     * Button Data Tracking
     */
    dataTracking = () => {
        window.digitalData = window.digitalData || [];
        const digitalData = window.digitalData || [];

        const fileDetail = {};
        fileDetail.fileName = this.elements.container.dataset.name || '';
        fileDetail.fileType = this.elements.container.dataset.type || '';
        fileDetail.fileCategory = this.elements.container.dataset.category || '';
        fileDetail.filePath = window.location.origin.concat(this.elements.container.dataset.path) || '';

        digitalData.push({
            event: 'fileDownload',
            fileDownloadDetail: fileDetail
        });
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.anchor.addEventListener('click', this.dataTracking);
    };

    /**
     * Initialize Component
     */
    init() {
        if (!this.elements.anchor || !this.elements.container) return;
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, Button);
